export const ASYNC_CREATE_EVENT = 'ASYNC_CREATE_EVENT';
export const ASYNC_EDIT_EVENT = 'ASYNC_EDIT_EVENT';
export const ASYNC_CREATE_EVENT_EXTRA_MATERIAL =
  'ASYNC_CREATE_EVENT_EXTRA_MATERIAL';
export const ASYNC_EDIT_EVENT_EXTRA_MATERIAL =
  'ASYNC_EDIT_EVENT_EXTRA_MATERIAL';
